import {
  CANCEL_BUTTON_VARIANT,
  YES_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifButton,
  MotifModalHeader,
} from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import { CommonModalHeader } from "../CommonModalHeader/CommonModalHeader";
import { useTrans } from "@/components/Functions/dateFunc";

type Props = {
  message: string;
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  cancelBtnHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  yesBtnHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  deleteLoading?: boolean;
  entityName?: any;
};

export default function DeleteModal({
  message,
  isVisible,
  setIsVisible,
  cancelBtnHandler,
  yesBtnHandler,
  deleteLoading,
  entityName,
}: Props) {
  const { t } = useTranslation();
  const transFunction = useTrans(
    t,
    t(message, {
      entityName: entityName,
    }),
    "entityName"
  );
  return (
    <>
      <MotifModal
        onClose={() => setIsVisible(false)}
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="confirmationModalWrapper creditor_disabling_model">
          <MotifModalHeader headerIcon={CommonModalHeader()}></MotifModalHeader>
          <MotifModalBody style={{ paddingTop: "0px" }}>
            <div>
              {entityName ? (
                transFunction
              ) : (
                <>
                  {" "}
                  {message}
                  {entityName && <strong> {entityName}</strong>}?
                </>
              )}
            </div>
          </MotifModalBody>
          <MotifModalFooter style={{ marginLeft: "Auto" }}>
            <MotifButton
              onClick={cancelBtnHandler}
              variant={CANCEL_BUTTON_VARIANT}
            >
              {t("global.globalActions.cancel")}
            </MotifButton>
            <MotifButton
              onClick={yesBtnHandler}
              variant={YES_BUTTON_VARIANT}
              loading={deleteLoading}
            >
              {t("global.globalActions.yes")}
            </MotifButton>
          </MotifModalFooter>
        </div>
      </MotifModal>
    </>
  );
}
